export default __webpack_public_path__ + "ecbb3bac46eb55f6f3028faf5c3702e2.png";